import { memo } from 'react';
import { Card, Box, BlockStack, Text, InlineStack, Divider, Bleed, Grid } from '@shopify/polaris';
import { ICardMediaAsset } from '@/types/media';
import MediaAssetCard from '../MediaAssetCard';

interface GeneratedMediaCardProps {
  title?: string;
  subtitle?: string;
  media?: ICardMediaAsset | ICardMediaAsset[];
  size?: 'medium' | 'large' | 'small';
  aspectRatio?: 'square' | 'portrait';
  mediaType?: 'Image' | 'Video';
  failed?: boolean;
  showProgressBannerWarning?: boolean;
}

const GeneratedMediaCard = ({
  title = 'Generated',
  subtitle = '',
  media,
  size = 'large',
  aspectRatio = 'portrait',
  mediaType = 'Image',
  failed = false,
  showProgressBannerWarning = false,
}: GeneratedMediaCardProps) => {
  return (
    <Card>
      <BlockStack>
        <Box paddingBlockEnd="400">
          <InlineStack gap="200">
            <Text variant="headingMd" as="h2" fontWeight="semibold">
              {title}
            </Text>
            <Text variant="headingSm" as="h3" tone="subdued">
              {mediaType}
            </Text>
          </InlineStack>
          {subtitle && (
            <Box>
              <Text as="p" variant="bodySm" tone="subdued">
                {subtitle}
              </Text>
            </Box>
          )}
        </Box>

        <Bleed marginInline="400">
          <Divider />
        </Bleed>

        <Box paddingBlockStart="400">
          {Array.isArray(media) ? (
            <InlineStack wrap gap="300">
              {media.map((m) => (
                <Box key={m.id} width="fit-content">
                  <MediaAssetCard
                    media={m}
                    size={size}
                    aspectRatio={aspectRatio}
                    hideMetadata
                    failed={failed}
                    actionButtonSize="micro"
                    showProgressBannerWarning={showProgressBannerWarning}
                  />
                </Box>
              ))}
            </InlineStack>
          ) : (
            <InlineStack align="center">
              <MediaAssetCard
                media={media}
                size={size}
                aspectRatio={aspectRatio}
                hideMetadata
                failed={failed}
                showProgressBannerWarning={showProgressBannerWarning}
              />
            </InlineStack>
          )}
        </Box>
      </BlockStack>
    </Card>
  );
};

GeneratedMediaCard.displayName = 'GeneratedMediaCard';

export default memo(GeneratedMediaCard);
